"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _events = _interopRequireDefault(require("./events"));

var _placements = _interopRequireDefault(require("./placements"));

var _infoBehaviourOnHover = _interopRequireDefault(require("./infoBehaviourOnHover"));

var _scrollAnimations = _interopRequireDefault(require("./scrollAnimations"));

var _infoType = _interopRequireDefault(require("./infoType"));

var _loadingMode = _interopRequireDefault(require("./loadingMode"));

var _textBoxHeightCalculationOptions = _interopRequireDefault(require("./textBoxHeightCalculationOptions"));

var _textBoxWidthCalculationOptions = _interopRequireDefault(require("./textBoxWidthCalculationOptions"));

var _overlayAnimations = _interopRequireDefault(require("./overlayAnimations"));

var _imageHoverAnimations = _interopRequireDefault(require("./imageHoverAnimations"));

var _layout = _interopRequireDefault(require("./layout"));

var _cubeType = _interopRequireDefault(require("./cubeType"));

var _itemClick = _interopRequireDefault(require("./itemClick"));

var _scrollDirection = _interopRequireDefault(require("./scrollDirection"));

var _thumbnailsAlignment = _interopRequireDefault(require("./thumbnailsAlignment"));

var _watermarkDock = _interopRequireDefault(require("./watermarkDock"));

var _loadMoreAmount = _interopRequireDefault(require("./loadMoreAmount"));

var _expandAnimations = _interopRequireDefault(require("./expandAnimations"));

var _horizontalAlign = _interopRequireDefault(require("./horizontalAlign"));

var _verticalAlign = _interopRequireDefault(require("./verticalAlign"));

var _videoPlay = _interopRequireDefault(require("./videoPlay"));

var _groupTypes = _interopRequireDefault(require("./groupTypes"));

var _mobileSwipeAnimations = _interopRequireDefault(require("./mobileSwipeAnimations"));

var _expandInfoPositions = _interopRequireDefault(require("./expandInfoPositions"));

var _dimensions = _interopRequireDefault(require("./dimensions"));

var _gallerySizeType = _interopRequireDefault(require("./gallerySizeType"));

var _isVertical = _interopRequireDefault(require("./isVertical"));

var _galleryTextAlign = _interopRequireDefault(require("./galleryTextAlign.js"));

var _gridStyle = _interopRequireDefault(require("./gridStyle"));

var _layoutDirection = _interopRequireDefault(require("./layoutDirection"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  events: _events["default"],
  placements: _placements["default"],
  infoBehaviourOnHover: _infoBehaviourOnHover["default"],
  scrollAnimations: _scrollAnimations["default"],
  infoType: _infoType["default"],
  loadingMode: _loadingMode["default"],
  layout: _layout["default"],
  itemClick: _itemClick["default"],
  textBoxHeightCalculationOptions: _textBoxHeightCalculationOptions["default"],
  textBoxWidthCalculationOptions: _textBoxWidthCalculationOptions["default"],
  scrollDirection: _scrollDirection["default"],
  cubeType: _cubeType["default"],
  thumbnailsAlignment: _thumbnailsAlignment["default"],
  watermarkDock: _watermarkDock["default"],
  loadMoreAmount: _loadMoreAmount["default"],
  expandAnimations: _expandAnimations["default"],
  overlayAnimations: _overlayAnimations["default"],
  imageHoverAnimations: _imageHoverAnimations["default"],
  horizontalAlign: _horizontalAlign["default"],
  verticalAlign: _verticalAlign["default"],
  videoPlay: _videoPlay["default"],
  groupTypes: _groupTypes["default"],
  mobileSwipeAnimations: _mobileSwipeAnimations["default"],
  expandInfoPositions: _expandInfoPositions["default"],
  dimensions: _dimensions["default"],
  gallerySizeType: _gallerySizeType["default"],
  isVertical: _isVertical["default"],
  galleryTextAlign: _galleryTextAlign["default"],
  gridStyle: _gridStyle["default"],
  layoutDirection: _layoutDirection["default"]
};
exports["default"] = _default;